var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgCatFrame = function SvgCatFrame(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#cat-frame_svg__a)",
    strokeWidth: 2.5,
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cat-frame_svg__a",
    x1: 7.4,
    x2: 9.246,
    y1: 4,
    y2: 19.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })))));
};
export default SvgCatFrame;